import React from "react";
import ModalSideBar from "../../../../../components/ModalSideBar";
import { maskCnpj, renderOperationTypes } from "../../../../../helpers/format";
import { IOperacaoAgendadaSPE } from "../types/types";

interface Props {
  data?: IOperacaoAgendadaSPE;
  title: string;
  onClose: () => void;
}

const Info: React.FC<Props> = (props: Props) => {
  return (
    <ModalSideBar isOpen title={props.title} onClose={props.onClose}>
      <div className="w-full h-full">
        <div className="w-full grid grid-cols-2 gap-2 gap-y-6">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              ID Agendamento SPE
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.id_operacao_porto_agendada_SPE ?? '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Data/Hora Agendamento
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.data_agendamento_terminal ?? '---'}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Placa Dianteira
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.placa_dianteira_veiculo ?? '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Placa Traseira
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.placa_traseira_veiculo ?? '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              CPF Motorista
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.cpf_motorista ?? '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              CNPJ Transportadora
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.cnpj_transportadora ? maskCnpj(props.data.cnpj_transportadora) : '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Identificadores Conteineres
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.identificadores_conteineres ?? '---'}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Terminal
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.terminal?.razao_social ?? '---'}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Tipo de Carga
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.tipo_carga ? String(props.data.tipo_carga) : '---'}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Tipo de Operação
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.tipo_operacao ? renderOperationTypes(props.data.tipo_operacao) : '---'}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Usuário Responsável
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.usuario ?? '---'}
            </span>
          </div>
        </div>
      </div>
    </ModalSideBar>
  );
};

export default Info;
